var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "global-filter-panel",
        [
          _c(
            "global-filter-group",
            [
              _c("global-input-field", {
                attrs: {
                  label: _vm.$t("mediaGallery.filter.keyword.label"),
                  value: _vm.keyword,
                },
                on: { input: _vm.handleSearchInput },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "global-filter-group",
            [
              _vm._l(_vm.filters, function (filter) {
                return [
                  _c("global-filter", {
                    attrs: { filter: filter },
                    on: { change: _vm.handleFilterChange },
                  }),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        [_c("media-gallery-selected-filters")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }